import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import loading from "./LoadingService";
import { clearAuthState, getAccessToken } from "../../utils/Autenticacao";

var countRequest = 0;
const ApiService2 = {
  async init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
    Vue.axios.defaults.timeout = 300000;
    await this.setHeader();

    axios.interceptors.request.use(
      config => {
        if (config.public) {
          delete config.headers.Authorization;
        } else {
          const token = getAccessToken();
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          } else {
            delete config.headers.Authorization;
          }
        }

        if (countRequest <= 0) {
          loading.show();
          countRequest = 0;
        }

        countRequest++;
        return config;
      },
      error => {
        countRequest--;
        this.verificarLoading();
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        countRequest--;
        this.verificarLoading();
        return response;
      },
      error => {
        countRequest--;
        this.verificarLoading();
        return Promise.reject(error);
      }
    );
  },

  async setHeader() {
    Vue.axios.defaults.headers.post["Content-Type"] = "application/json";
  },

  async query(resource, params, config = {}) {
    try {
      return await Vue.axios.get(resource, {
        params,
        ...config
      });
    } catch (error) {
      const result = {
        message: this.genericErrorHandling(error),
        status: error.response && error.response.status
      };

      return Promise.reject(result);
    }
  },

  async get(resource, slug = "", config = {}) {
    try {
      return await Vue.axios.get(`${resource}/${slug}`, config);
    } catch (error) {
      const result = {
        message: this.genericErrorHandling(error),
        status: error.response && error.response.status
      };

      if (result) {
        return Promise.reject(result);
      }
    }
  },

  async downloadGet(
    path,
    params,
    fallbackFilename = "download",
    publicRequest = false
  ) {
    try {
      const { data, headers } = await Vue.axios.get(path, {
        params,
        responseType: "blob",
        public: publicRequest
      });

      const filename =
        this.extractFilename(headers["content-disposition"]) ||
        fallbackFilename;

      this.redirectToDownload(data, filename);

      return data;
    } catch (error) {
      return Promise.reject({
        message: this.genericErrorHandling(error),
        status: error.response && error.response.status
      });
    }
  },

  redirectToDownload(data, filename) {
    const url = URL.createObjectURL(data);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(url);
  },

  extractFilename(contentDisposition) {
    if (!contentDisposition) return null;

    const match = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
    );

    return match ? decodeURIComponent(match[1]) : null;
  },

  extrairErrosCampo(data) {
    if (!data || typeof data !== "object" || Array.isArray(data)) {
      return null;
    }
    if (
      Object.prototype.hasOwnProperty.call(data, "message") &&
      typeof data.message === "string" &&
      Object.keys(data).length === 1
    ) {
      return null;
    }
    const keys = Object.keys(data);
    if (keys.length === 0 || !keys.every(k => typeof data[k] === "string")) {
      return null;
    }
    return { ...data };
  },

  montarResultadoErro(error) {
    const status = error.response && error.response.status;
    const data = error.response && error.response.data;
    const fieldErrors = status === 400 ? this.extrairErrosCampo(data) : null;

    return {
      message: this.genericErrorHandling(error, fieldErrors),
      status,
      fieldErrors
    };
  },

  async post(resource, params, config = {}) {
    try {
      return await Vue.axios.post(`${resource}`, params, config);
    } catch (error) {
      return Promise.reject(this.montarResultadoErro(error));
    }
  },

  async update(resource, slug, params) {
    try {
      return await Vue.axios.put(`${resource}/${slug}`, params);
    } catch (error) {
      const result = {
        message: this.genericErrorHandling(error),
        status: error.response && error.response.status
      };

      return Promise.reject(result);
    }
  },

  async put(resource, params) {
    try {
      return await Vue.axios.put(`${resource}`, params);
    } catch (error) {
      const result = {
        message: this.genericErrorHandling(error),
        status: error.response && error.response.status
      };

      return Promise.reject(result);
    }
  },

  async delete(resource) {
    try {
      return await Vue.axios.delete(resource);
    } catch (error) {
      const result = {
        message: this.genericErrorHandling(error),
        status: error.response && error.response.status
      };

      return Promise.reject(result);
    }
  },

  genericErrorHandling(error, fieldErrors) {
    let { message } = error;

    if (error && error.response && error.response.status) {
      const data = error.response.data;
      switch (error.response.status) {
        case 401:
          this.handling401(data);
          message = "";
          break;
        case 404:
          message = data.message;
          break;
        case 500:
          message = data.message;
          break;
        default:
          if (fieldErrors) {
            message = [...new Set(Object.values(fieldErrors))].join("\n");
          } else if (data && data.message) {
            message = data.message;
          } else if (typeof data === "string") {
            message = data;
          }
          break;
      }
    }

    return message;
  },

  handling401() {
    clearAuthState();
    if (countRequest == 0) {
      window.location.hash = "#/login";
    }
  },

  handling500() {
    // const message = 'Erro ao tentar realizar a operação solicitada. Entre em contato com o administrador do sistema.'
    // return message
  },

  handlingWarning(error) {
    let message = "";

    if (error.response && error.response.data && error.response.data.message) {
      try {
        const msg = JSON.parse(error.response.data.message);
        message = msg.message;
      } catch (e) {
        message = error.response.data.message;
      }

      Vue.noty.warning(message);
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.errors
    ) {
      error.response.data.errors.forEach(e => {
        message = message + "," + e;
        Vue.noty.warning(e);
      });
    }

    return message;
  },

  verificarLoading() {
    if (countRequest <= 0) {
      loading.hide();
    }
  }
};

export default ApiService2;
